import { Menu } from '../types/menu';

export const MENU_EVENT = 'menu-event';

export const OPEN_USER_MENU_EVENT = new CustomEvent(MENU_EVENT, { detail: Menu.USER_MENU });

export const OPEN_CART_MENU_EVENT = new CustomEvent(MENU_EVENT, { detail: Menu.CART_MENU });

export const CLOSE_MENU_EVENT = new CustomEvent(MENU_EVENT, { detail: Menu.NONE });
